import React, { useState, useEffect } from 'react';
import {
  Table,
  Button,
  Form,
  InputGroup,
  Pagination,
  Modal,
  Row,
  Col
} from 'react-bootstrap';
import { FaUser, FaEnvelope, FaPhone, FaBuilding, FaMapMarkerAlt, FaCity, FaIdCard, FaCheckCircle, FaTimesCircle, FaClock } from 'react-icons/fa';

import axios from 'axios';

const UserTable = () => {
  const [users, setUsers] = useState([]);
  const [roleFilter, setRoleFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
const [selectedSeller, setSelectedSeller] = useState(null);

const openSellerModal = (seller) => {
  setSelectedSeller(seller);
  setShowModal(true);
};

  const usersPerPage = 5;

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [searchTerm, roleFilter, users]);

  const fetchUsers = async () => {
    try {
      const res = await axios.get('https://vyaparapi.emedha.in/api/auth/user-profiles'); // Replace with your actual API
      const combined = [...res.data.sellers, ...res.data.buyers];
      setUsers(combined);
    } catch (err) {
      console.error('Error fetching users:', err);
    }
  };

  const applyFilters = () => {
    let result = users;

    if (roleFilter !== 'all') {
      result = result.filter((u) => u.role === roleFilter);
    }

    if (searchTerm.trim() !== '') {
      result = result.filter((u) =>
        u.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredUsers(result);
    setCurrentPage(1);
  };

const handleApproveReject = async (userId, status) => {
  try {
    const response = await axios.put(`https://vyaparapi.emedha.in/api/auth/approve-user/${userId}`, {
      status,
    });

    if (response.status === 200) {
      // Optional: Success toast or alert
      alert(`User ${status === 1 ? 'approved' : 'rejected'} successfully!`);
      fetchUsers(); // Refresh user list
    }
  } catch (error) {
    console.error('Error updating approval status:', error);
    alert('Something went wrong while updating user approval status.');
  }
};



  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

  return (
    <div
      className="container mt-4"
      style={{
        color: '#fff',
        backgroundColor: '#062d59',
        padding: '20px',
        borderRadius: '8px',
      }}
    >
      <h3 style={{ color: '#fff' }}>User Profiles</h3>

      <Row className="mb-3 mt-3">
        <Col md={6}>
          <InputGroup>
            <Form.Control
              placeholder="Search by name"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </InputGroup>
        </Col>
        <Col md={6}>
          <Form.Select
            value={roleFilter}
            onChange={(e) => setRoleFilter(e.target.value)}
          >
            <option value="all">All Roles</option>
            <option value="seller">Seller</option>
            <option value="buyer">Buyer</option>
          </Form.Select>
        </Col>
      </Row>

      <Table responsive bordered hover variant="light">
        <thead>
          <tr style={{ backgroundColor: '#e3080c', color: '#fff' }}>
            <th>#</th>
            <th>Name</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>Role</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {currentUsers.map((user, index) => (
            <tr key={user.user_id}>
              <td>{indexOfFirstUser + index + 1}</td>
      <td>
  {user.role === 'seller' ? (
    <Button
      variant="link"
      style={{ color: 'black', padding: 0 }}
      onClick={() => openSellerModal(user)}
    >
      {user.name}
    </Button>
  ) : (
    user.name
  )}
</td>

              <td>{user.email}</td>
              <td>{user.mobile}</td>
              <td>{user.role}</td>
              <td>
                {user.role === 'buyer' &&  user.role === 'seller'? (
                  <span>-</span>
                ) : user.is_approve === 1 ? (
                  <span className="text-success">Approved</span>
                ) : user.is_approve === 0 ? (
                  <span className="text-danger">Rejected</span>
                ) : (
                  <span className="text-warning">Pending</span>
                )}
              </td>
<td>
  {(user.role === 'seller' || user.role === 'buyer') && (
    <>
      {user.is_approve === 1 ? (
        <Button
          size="sm"
          variant="danger"
          onClick={() =>
            window.confirm(`Reject ${user.role}?`) &&
            handleApproveReject(user.user_id, 0)
          }
        >
          Reject
        </Button>
      ) : user.is_approve === 0 ? (
        <Button
          size="sm"
          variant="success"
          onClick={() =>
            window.confirm(`Approve ${user.role}?`) &&
            handleApproveReject(user.user_id, 1)
          }
        >
          Approve
        </Button>
      ) : (
        <>
          <Button
            size="sm"
            variant="success"
            className="me-2"
            onClick={() =>
              window.confirm(`Approve ${user.role}?`) &&
              handleApproveReject(user.user_id, 1)
            }
          >
            Approve
          </Button>
          <Button
            size="sm"
            variant="danger"
            onClick={() =>
              window.confirm(`Reject ${user.role}?`) &&
              handleApproveReject(user.user_id, 0)
            }
          >
            Reject
          </Button>
        </>
      )}
    </>
  )}
</td>

            </tr>
          ))}
        </tbody>
      </Table>

      <Pagination className="justify-content-center">
        {[...Array(totalPages).keys()].map((num) => (
          <Pagination.Item
            key={num}
            active={num + 1 === currentPage}
            onClick={() => setCurrentPage(num + 1)}
          >
            {num + 1}
          </Pagination.Item>
        ))}
      </Pagination>

      {/* Seller Modal */}
   <>
      <style>{`
        /* Higher z-index for modal and backdrop */
        .custom-modal .modal-backdrop {
          z-index: 1999 !important;
        }
        .custom-modal .modal-dialog {
          z-index: 2000 !important;
        }

        /* Two columns grid */
        .modal-body .row {
          display: flex;
          flex-wrap: wrap;
          gap: 1rem;
        }
          .custom-modal .btn-close {
  filter: invert(1); /* Turns the icon white */
}
        .modal-body .field {
          flex: 1 1 45%; /* two fields per row with some gap */
          min-width: 150px;
        }
        /* Responsive: stack fields vertically on small screens */
        @media (max-width: 480px) {
          .modal-body .field {
            flex: 1 1 100%;
          }
        }
      `}</style>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        dialogClassName="custom-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton style={{ backgroundColor: '#062d59', color: '#fff' }}>
          <Modal.Title><FaBuilding style={{ marginRight: 8 }} /> Seller Details</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ backgroundColor: '#fff', maxHeight: '60vh', overflowY: 'auto', padding: '1.5rem' }}>
          {selectedSeller ? (
            <div className="row" style={{ color: '#062d59', fontSize: '1rem' }}>
              <div className="field"><FaUser color="#e3080c" style={{ marginRight: 8 }} /><strong>Name:</strong> {selectedSeller.name}</div>
              <div className="field"><FaEnvelope color="#e3080c" style={{ marginRight: 8 }} /><strong>Email:</strong> {selectedSeller.email}</div>
              <div className="field"><FaPhone color="#e3080c" style={{ marginRight: 8 }} /><strong>Mobile:</strong> {selectedSeller.mobile}</div>
              <div className="field"><FaBuilding color="#e3080c" style={{ marginRight: 8 }} /><strong>Business Category:</strong> {selectedSeller.business_category}</div>
              <div className="field"><FaMapMarkerAlt color="#e3080c" style={{ marginRight: 8 }} /><strong>State:</strong> {selectedSeller.state}</div>
              <div className="field"><FaCity color="#e3080c" style={{ marginRight: 8 }} /><strong>City:</strong> {selectedSeller.city}</div>
              <div className="field"><FaIdCard color="#e3080c" style={{ marginRight: 8 }} /><strong>GST Number:</strong> {selectedSeller.gst_number}</div>
              <div className="field"><FaIdCard color="#e3080c" style={{ marginRight: 8 }} /><strong>Aadhar Number:</strong> {selectedSeller.aadhar_number}</div>
              <div className="field">
                <strong>GST Verified:</strong> {selectedSeller.gst_verify === 1 ? (
                  <FaCheckCircle color="green" style={{ marginLeft: 8 }} />
                ) : (
                  <FaTimesCircle color="red" style={{ marginLeft: 8 }} />
                )}
              </div>
              <div className="field">
                <strong>Aadhar Verified:</strong> {selectedSeller.aadhar_verify === 1 ? (
                  <FaCheckCircle color="green" style={{ marginLeft: 8 }} />
                ) : (
                  <FaTimesCircle color="red" style={{ marginLeft: 8 }} />
                )}
              </div>
              <div className="field">
                <strong>Approval Status:</strong> {
                  selectedSeller.is_approve === 1 ? (
                    <span style={{ color: 'green', fontWeight: 'bold' }}>Approved</span>
                  ) : selectedSeller.is_approve === 0 ? (
                    <span style={{ color: 'red', fontWeight: 'bold' }}>Rejected</span>
                  ) : (
                    <span style={{ color: '#e3a200', fontWeight: 'bold' }}>Pending</span>
                  )
                }
              </div>
              <div className="field"><FaClock color="#e3080c" style={{ marginRight: 8 }} /><strong>Created At:</strong> {new Date(selectedSeller.profile_created_at).toLocaleString()}</div>
            </div>
          ) : (
            <p>Loading...</p>
          )}
        </Modal.Body>

        <Modal.Footer style={{ backgroundColor: '#062d59' }}>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>

    </div>
  );
};

export default UserTable;
